// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Eq3-u","title":"FrontImage_title__2oPGG"};